import { useEffect, useState } from "react";
import { Youtube, ArrowRight } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/site/Reveal";
import { VideoCard } from "@/components/sections/VideoCard";
import { api } from "@/lib/api";

export const YoutubeSection = () => {
  const [videos, setVideos] = useState([]);
  const [settings, setSettings] = useState({});

  useEffect(() => {
    api.get("/videos").then((r) => setVideos(r.data)).catch(() => {});
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const subscribeUrl = settings.youtube_subscribe_url || settings.youtube_channel_url || "";
  const [featured, ...rest] = videos;

  return (
    <section className="py-24 lg:py-32" data-testid="youtube-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
          <Reveal className="max-w-2xl">
            <SectionLabel>YouTube</SectionLabel>
            <h2 className="mt-4 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
              FOLLOW THE JOURNEY ON YOUTUBE
            </h2>
            <p className="mt-5 text-brand-textSec leading-relaxed">
              The YouTube channel documents the real process of building the fish room and the business —
              the wins, the failures, the money in and the money out. All of it, honestly.
            </p>
          </Reveal>
          <a
            href={subscribeUrl || "#"}
            onClick={(e) => !subscribeUrl && e.preventDefault()}
            target={subscribeUrl ? "_blank" : undefined}
            rel="noreferrer"
            data-testid="subscribe-youtube-btn"
            className="btn-primary px-6 py-3 text-sm inline-flex items-center gap-2 shrink-0"
          >
            <Youtube size={18} /> Subscribe on YouTube
          </a>
        </div>

        {featured && (
          <Reveal>
            <div className="grid lg:grid-cols-2 gap-8 items-stretch mb-8">
              <VideoCard video={featured} featured />
              <div className="flex flex-col justify-center card-surface p-8">
                <SectionLabel>Latest Episode</SectionLabel>
                <h3 className="mt-3 font-display font-bold text-2xl text-white leading-tight">{featured.title}</h3>
                <p className="mt-4 text-brand-textSec leading-relaxed">{featured.description}</p>
                <a
                  href={subscribeUrl || "#"}
                  onClick={(e) => !subscribeUrl && e.preventDefault()}
                  target={subscribeUrl ? "_blank" : undefined}
                  rel="noreferrer"
                  className="mt-6 text-brand-cyan text-sm font-medium inline-flex items-center gap-2 hover:gap-3 transition-all"
                >
                  Watch on YouTube <ArrowRight size={16} />
                </a>
              </div>
            </div>
          </Reveal>
        )}

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {rest.map((v, i) => (
            <Reveal key={v.id} delay={i * 0.08}>
              <VideoCard video={v} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
